import { jsx as _jsx } from "react/jsx-runtime";
/**
 * OnboardingActionsContext — partage le slot d'actions (CTA) du flow.
 *
 * Sprint 2.2 L2 — fix UX mobile : le clavier qui s ouvre dans Signup
 * ne doit PAS masquer "Créer mon compte". On déplace les CTA dans un
 * footer sticky bottom safe-area géré par OnboardingFlow, et chaque
 * écran (Welcome, AgeBand, Signup, Intent) injecte son contenu
 * via `useOnboardingActions().setActions(node)`.
 *
 * Pattern :
 *   const { setActions } = useOnboardingActions();
 *   useEffect(() => {
 *     setActions(<button>...</button>);
 *     return () => setActions(null);
 *   }, [...deps]);
 */
import { createContext, useCallback, useContext, useMemo, useState, } from 'react';
const Ctx = createContext(null);
export function OnboardingActionsProvider({ children }) {
    const [actions, setActionsState] = useState(null);
    const setActions = useCallback((node) => setActionsState(node), []);
    const value = useMemo(() => ({ actions, setActions }), [actions, setActions]);
    return _jsx(Ctx.Provider, { value: value, children: children });
}
export function useOnboardingActions() {
    const v = useContext(Ctx);
    if (!v) {
        return {
            actions: null,
            setActions: () => undefined,
        };
    }
    return v;
}
//# sourceMappingURL=OnboardingActionsContext.js.map